// extracted by mini-css-extract-plugin
export default {"box":"signupForm_box__YewkG"};